var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.407 13.4073C14.0946 12.7197 15.0272 12.3334 15.9997 12.3334C16.9721 12.3334 17.9048 12.7197 18.5924 13.4073C19.28 14.0949 19.6663 15.0276 19.6663 16C19.6663 16.9725 19.28 17.9051 18.5924 18.5928C17.9048 19.2804 16.9721 19.6667 15.9997 19.6667C15.0272 19.6667 14.0946 19.2804 13.407 18.5928C12.7193 17.9051 12.333 16.9725 12.333 16C12.333 15.0276 12.7193 14.0949 13.407 13.4073ZM15.9997 14.3334C15.5576 14.3334 15.1337 14.509 14.8212 14.8215C14.5086 15.1341 14.333 15.558 14.333 16C14.333 16.4421 14.5086 16.866 14.8212 17.1786C15.1337 17.4911 15.5576 17.6667 15.9997 17.6667C16.4417 17.6667 16.8656 17.4911 17.1782 17.1786C17.4907 16.866 17.6663 16.4421 17.6663 16C17.6663 15.558 17.4907 15.1341 17.1782 14.8215C16.8656 14.509 16.4417 14.3334 15.9997 14.3334Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.238 16.0625C6.40065 17.7605 7.92789 19.4177 9.6735 20.6866C11.6251 22.1054 13.7936 23 16 23C18.2064 23 20.3749 22.1054 22.3265 20.6866C24.0721 19.4177 25.5994 17.7605 26.762 16.0625C23.7713 12.4071 20.5601 9 16 9C11.4399 9 8.22867 12.4071 5.238 16.0625ZM3.22254 15.3711C6.22923 11.6542 10.107 7 16 7C21.893 7 25.7708 11.6542 28.7775 15.3711C29.0469 15.7041 29.0742 16.1718 28.8455 16.534C27.528 18.6201 25.6839 20.7186 23.5025 22.3044C21.3231 23.8886 18.7509 25 16 25C13.2491 25 10.6769 23.8886 8.49751 22.3044C6.31615 20.7186 4.47205 18.6201 3.15451 16.534C2.92576 16.1718 2.95312 15.7041 3.22254 15.3711Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeEmpty);
export default __webpack_public_path__ + "static/media/eye-empty.2bdb5eca9dcdf264cf5705b58d07dd68.svg";
export { ForwardRef as ReactComponent };